import { useAppContext } from 'hooks/useAppContext';

const useMapLoadedStatus = () => {
  const {
    state: {
      map: { isLoaded, zoomLevel },
    },
    dispatch,
  } = useAppContext();

  const dispatchStatus = (isMapLoaded: boolean): void => {
    dispatch({ type: 'set_is_map_loaded', payload: isMapLoaded });
  };

  const dispatchZoomLevel = (zoom: number) => {
    dispatch({ type: 'set_map_zoom_level', payload: { zoomLevel: zoom } });
  };

  return {
    isLoaded,
    zoomLevel,
    dispatchStatus,
    dispatchZoomLevel,
  };
};

export { useMapLoadedStatus };
